module.exports = __webpack_public_path__ + "img/image.37f1cc46.png";